import React, { Component } from 'react';

import AboutSection from '../components/AboutUs/Page.js';
import FooterSection from '../components/Footer';
import Header from '../components/Header/header';
import HeroSection from '../components/HeroSection/HeroSectionBlog';

class Theme extends Component {
  render() {
    return (
      <React.Fragment>
        <Header />
        <div className="main">
          <HeroSection title="¿Quienes somos?" breadcrumbs={['Inicio', 'Páginas', 'Sobre Nosotros']}/>
          <AboutSection />
        </div>
        <FooterSection noSubscription={true} />
      </React.Fragment>
    );
  }
}

export default Theme;